//@flow
import React from "react";
import "./banner.scss";

export function Banner() {
  return (
    <div className="product-listing-header-wrapper">
      <div className="product-listing-header">
        <div className="product-listing-header__cat-banner cat-banner">
          <div>
            <h1 className="cat-banner__title">My Wishlist</h1>
          </div>
        </div>
      </div>
    </div>
  );
}
